export enum TaskStatusSelectEnum {
  RECTANGLES = 'RECTANGLES',
  DOTS = 'DOTS'
}
